(() => {
  'use strict';
  const initialize = (root = document) => {
    root.querySelectorAll('[data-announcement-ticker]').forEach(ticker => {
      if (ticker.dataset.tickerReady) return;
      const toggle = ticker.querySelector('[data-ticker-toggle]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = false;
      let visible = true;
      const sync = () => {
        ticker.classList.toggle('is-static', paused || motion.matches);
        ticker.classList.toggle('is-idle', !visible || document.hidden);
        toggle.hidden = motion.matches;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      };
      toggle.addEventListener('click', () => { paused = !paused; sync(); });
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        sync();
      }) : null;
      observer?.observe(ticker);
      motion.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      ticker.dataset.tickerReady = 'true';
      sync();
      const unload = event => {
        if (!event.target.contains(ticker)) return;
        observer?.disconnect();
        motion.removeEventListener('change', sync);
        document.removeEventListener('visibilitychange', sync);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
